import http from "../http";

/**
 * Get notifications
 * @param {Object} params - Query parameters
 * @returns {Promise} API response
 */
export function getNotifications(params) {
  return http.get("/buyer/notification", { params });
}

/**
 * Get notification count (all types)
 * @returns {Promise} API response
 */
export function getNotificationCount() {
  return http.get("/buyer/notification/count");
}

/**
 * Mark a notification as read
 * @param {string|number} notificationId - Notification ID
 * @returns {Promise} API response
 */
export function markNotificationAsRead(notificationId) {
  return http.patch(`/buyer/notification/read/${notificationId}`);
}

/**
 * Mark all notifications as read
 * @returns {Promise} API response
 */
export function markAllNotificationsAsRead() {
  return http.patch("/buyer/notification/read/all");
}

/**
 * Delete a notification
 * @param {string|number} notificationId - Notification ID
 * @returns {Promise} API response
 */
export function deleteNotification(notificationId) {
  return http.post(`/buyer/notification/delete/${notificationId}`);
}

/**
 * Clear all notifications
 * @returns {Promise} API response
 */
export function clearNotifications() {
  return http.post("/buyer/notification/clear");
}
